import { render, staticRenderFns } from "./OptionHealthAttorneysPrimaryWorkTogetherOther.vue?vue&type=template&id=8ee3139e"
import script from "./OptionHealthAttorneysPrimaryWorkTogetherOther.vue?vue&type=script&lang=js"
export * from "./OptionHealthAttorneysPrimaryWorkTogetherOther.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports